import { render } from "./AdvancedBox.vue?vue&type=template&id=7a9cfd48"
import script from "./AdvancedBox.vue?vue&type=script&lang=js"
export * from "./AdvancedBox.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__